import { TotalPrice } from './TotalPrice'

export { TotalPrice }
